import { BadgeProps } from '@chakra-ui/react';

export const remote: BadgeProps = {
  backgroundColor: 'purple.200',
  color: 'primary.500',
  textTransform: 'capitalize',
};
